module.exports = __webpack_public_path__ + "img/vision.543f0e29.png";